import { render } from "./Signup.vue?vue&type=template&id=1b92fcf6"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=1b92fcf6&lang=css"

import exportComponent from "/home/iman/projects/cornerstone-register/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__